/**
 * Styles for Email Ad Validation components
 */
import { theme } from '../../theme/theme';

export const emailAdValidationStyles = {
  // Main page styles
  title: {
    margin: '15px 0 0 0',
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    color: '#333',
  },
  button: {
    fontWeight: '600',
    textTransform: 'none',
    marginBottom: '5px',
    marginLeft: '10px',
  },
  icon: {
    fontSize: '14px !important',
  },
  validationContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 20,
  },

  // Form styles
  formContainer: {
    marginTop: '20px',
  },
  card: {
    padding: '30px',
    marginBottom: '20px',
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  },
  formField: {
    marginBottom: '20px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    gap: '15px',
    marginTop: '30px',
    justifyContent: 'flex-start',
  },
  startButton: {
    backgroundColor: '#4caf50',
    color: 'white',
    fontWeight: '600',
    textTransform: 'none',
    padding: '10px 20px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#45a049',
    },
  },
  cancelButton: {
    backgroundColor: '#666',
    color: 'white',
    fontWeight: '600',
    textTransform: 'none',
    padding: '10px 20px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#555',
    },
  },
  dateRangeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '20px',
  },

  // Table styles (matching promotions table)
  tableContainer: {
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    overflow: 'hidden',
    marginTop: '10px',
  },
  tableHeader: {
    backgroundColor: '#404040',
    '& .MuiTableCell-head': {
      color: 'white',
      fontWeight: 'bold',
      fontSize: '14px',
      padding: '16px',
      borderBottom: 'none',
      cursor: 'pointer',
    },
    '& .MuiTableCell-head:hover': {
      backgroundColor: '#505050',
    },
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f9f9f9',
    },
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  tableCell: {
    fontSize: '13px',
    padding: '12px 16px',
    borderBottom: '1px solid #e0e0e0',
  },

  // Status chip styles (matching theme colors)
  statusChip: {
    fontWeight: 'bold',
    fontSize: '11px',
    height: '24px',
    textTransform: 'uppercase',
  },
  completedChip: {
    backgroundColor: theme.palette.published,
    color: 'white',
  },
  runningChip: {
    backgroundColor: theme.palette.draft,
    color: 'white',
  },
  failedChip: {
    backgroundColor: '#f44336',
    color: 'white',
  },

  // Action buttons
  actionButton: {
    padding: '4px',
    margin: '0 2px',
    color: '#666',
    '&:hover': {
      color: '#333',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  linkButton: {
    color: '#1976d2',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '13px',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  // No data state
  noDataContainer: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#666',
    backgroundColor: '#fafafa',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },

  // Sort icons
  sortIcon: {
    marginLeft: '4px',
    fontSize: '16px',
  },
  headerCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  // Filter styles
  clearFilterButton: {
    backgroundColor: theme.palette.promotionStatus.closed,
    marginRight: '6px',
    textTransform: 'none',
    fontWeight: '600',
    height: '40px',
    '&:hover': {
      backgroundColor: '#ccc',
    },
  },
};
